import {
    GET_CONFIG_FORM14,
    GET_DATOS_GESTION_IMPLICADO,
    GET_DATOS_GESTION_IMPLICADO_DEFAULT,
    GET_COMBO_REGISTRAR_HITOS,
    POST_ACTUALIZAR_EXTRAJUDICIAL,
    GET_LISTA_IMPLICADOS
    
} from '../types';


export default function procesoExtrajudicialReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM14:
            return { ...state, cfg_form14:action.payload }
        case GET_DATOS_GESTION_IMPLICADO:
            return { ...state, datosGestionImplicado:action.payload }
        case GET_DATOS_GESTION_IMPLICADO_DEFAULT:
            return { ...state, datosGestionImplicadoDefault: action.payload }
        case GET_COMBO_REGISTRAR_HITOS:
            return { ...state, comboRegistrarHitos:action.payload }    
        case POST_ACTUALIZAR_EXTRAJUDICIAL:
            return { ...state, respuestaExtrajudicial:action.payload }
        case GET_LISTA_IMPLICADOS:
            return { ...state, listaImplicados:action.payload}
       
        default:
            return state
    }
}